import axios from 'axios';
import { getLanguage } from '../i18n/language';

export const RESEARCH_API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const apiError = (error) => {
  const detail = error?.response?.data?.detail;
  return typeof detail === 'string' ? detail : error?.message || 'Something went wrong. Please retry.';
};
export const money = (value) => value == null ? '—' : new Intl.NumberFormat('en-US', {
  style: 'currency', currency: 'USD', maximumFractionDigits: Math.abs(value) < 1 ? 6 : 2,
}).format(value);
export const decimal = (value, digits = 2) => value == null ? '—' : Number(value).toFixed(digits);
export const dateLabel = (value) => new Date(value).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
export const getResearch = (path, config = {}) => axios.get(`${RESEARCH_API}${path}`, { timeout: 35000, ...config });
export const postResearch = (path, body, config = {}) => axios.post(`${RESEARCH_API}${path}`, body, { timeout: 35000, ...config });

export async function readResearchStream(path, body, onEvent, signal) {
  const token = localStorage.getItem('session_token');
  const response = await fetch(`${RESEARCH_API}${path}`, {
    method: 'POST', credentials: 'include', signal,
    headers: { 'Content-Type': 'application/json', 'Accept-Language': getLanguage(), ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const error = await response.json().catch(() => ({}));
    throw new Error(typeof error.detail === 'string' ? error.detail : 'The request could not be completed. Please retry.');
  }
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '', complete = false;
  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;
      buffer += decoder.decode(value, { stream: true });
      let end;
      while ((end = buffer.indexOf('\n\n')) >= 0) {
        const block = buffer.slice(0, end); buffer = buffer.slice(end + 2);
        const event = block.split('\n').find(line => line.startsWith('event:'))?.slice(6).trim();
        const payload = block.split('\n').filter(line => line.startsWith('data:')).map(line => line.slice(5).trim()).join('\n');
        if (!payload) continue;
        const data = JSON.parse(payload);
        if (event === 'error') throw new Error(data.message);
        if (event === 'done') complete = true;
        onEvent(event, data);
      }
    }
    if (!complete) throw new Error('The response was interrupted. Please retry.');
  } finally {
    await reader.cancel().catch(() => {});
    reader.releaseLock();
  }
}

export function downloadReport(name, text) {
  const url = URL.createObjectURL(new Blob([text], { type: 'text/markdown;charset=utf-8' }));
  const link = document.createElement('a');
  link.href = url; link.download = name; link.click();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}